var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Chips',{attrs:{"icon":_vm.icon,"text":_vm.text},on:{"isPushChips":function($event){return _vm.addDetailsOpratipon($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }